import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent, defineAsyncComponent } from "vue";
import VoiceSelector from "./voiceSelector.vue";
// import { Bar, Line, Pie, Doughnut } from 'vue-chartjs';
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement, ArcElement } from 'chart.js'
// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement, ArcElement)

var privacyPolicy = defineAsyncComponent(function () {
  return import("./mainMenuPages/privacyPolicy.vue");
});
var releaseNotes = defineAsyncComponent(function () {
  return import("./mainMenuPages/releaseNotes.vue");
});
var communityGuidelines = defineAsyncComponent(function () {
  return import("./mainMenuPages/communityGuidelines.vue");
});
var termsOfService = defineAsyncComponent(function () {
  return import("./mainMenuPages/termsOfService.vue");
});
var mainMenuNavigationItem = defineAsyncComponent(function () {
  return import("./mainMenuPages/mainMenuNavigationItem.vue");
});
// const ToggleComponent = defineAsyncComponent(() =>
// 	import('@/components/form/ToggleComponent.vue')
// )

var pageTitles = {
  mainMenu: "Main Menu",
  avatarSettings: "AIVitar Settings",
  billing: "Purchases & Subscriptions",
  policiesAndTerms: "Policies & Terms",
  howToDocs: "How To Documentation & Tutorials",
  termsOfService: "Terms Of Service",
  privacyPolicy: "Privacy Policy",
  cookiePolicy: "Cookie Policy",
  communityGuidelines: "Community Guidelines",
  feedbackSupport: "Feedback & Support",
  releaseNotes: "Release Notes",
  policyAndTerms: "Policies & Terms"
};
var icons = {
  howToDocs: "fa-book",
  avatarSettings: "fa-user-ninja",
  billing: "fa-money-bill",
  policiesAndTerms: "fa-folder-open",
  feedbackSupport: "fa-handshake-angle",
  releaseNotes: "fa-rectangle-list",
  privacyPolicy: "fa-file-lines",
  termsOfService: "fa-file-lines",
  cookiePolicy: "fa-cookie",
  communityGuidelines: "fa-scale-balanced",
  tour: "person-hiking"
};
export default defineComponent({
  name: "MainMenu",
  components: {
    termsOfService: termsOfService,
    mainMenuNavigationItem: mainMenuNavigationItem,
    communityGuidelines: communityGuidelines,
    privacyPolicy: privacyPolicy,
    releaseNotes: releaseNotes,
    // ToggleComponent,
    // Bar, Line, Pie, Doughnut,
    VoiceSelector: VoiceSelector
  },
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log("<<<<<<<<< MainMenu mounted >>>>>>>>>");
            _this.resetAllMenuViews();
            _this.showMainMenu = true;
            if (localStorage.getItem("pwaOptedOut") === "true" || localStorage.getItem("pwaOptedOut") === true) {
              // this.showPwaOptIn = true;
              _this.mainMenu.menuItems.push({
                clickEventType: "method",
                clickEvent: "reAllowAppInstall",
                label: "Re-allow app install",
                icon: "fa-mobile-screen-button"
              });
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  props: {},
  data: function data() {
    return {
      tokenBalance: 0,
      tokenBalanceError: false,
      monthlyTotals: {},
      chartType: "bar",
      width: 400,
      height: 400,
      //billing details
      billingLoaded: false,
      tokenData: [],
      months: [],
      selectedMonth: "",
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function label(context) {
                return "$".concat((context.dataset.data[context.dataIndex] * 0.00012).toFixed(2)); // Calculate cost per day used
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function callback(value) {
                  return "$" + value.toFixed(2);
                }
              }
            }
          }
        }
      },
      //end billing

      pageTitles: pageTitles,
      icons: icons,
      showAvatarSettings: false,
      showBilling: false,
      showMainMenu: true,
      showVoiceSettings: false,
      showTermsOfService: false,
      showFeedback: false,
      showReleaseNotes: false,
      showHowToDocs: false,
      showPoliciesAndTerms: false,
      showPrivacyPolicy: false,
      showFeedbackSupport: false,
      showCommunityGuidelines: false,
      // Main Menu
      mainMenu: {
        breadcrumbs: [{
          label: pageTitles.mainMenu,
          clickEvent: "showMainMenu"
        }],
        menuItems: [
        // {
        // 	clickEvent: 'showHowToDocs',
        // 	label: pageTitles.howToDocs,
        // 	icon: icons.howToDocs
        // },
        {
          clickEvent: "showAvatarSettings",
          label: pageTitles.avatarSettings,
          icon: icons.avatarSettings
        }, {
          clickEvent: "updateShowFAQ",
          clickValue: true,
          clickEventType: "store",
          label: "F.A.Q. & How To Docs",
          icon: icons.howToDocs
        }, {
          clickEvent: "showBilling",
          label: pageTitles.billing,
          icon: icons.billing
        }, {
          clickEvent: "showPoliciesAndTerms",
          label: pageTitles.policiesAndTerms,
          icon: icons.policiesAndTerms
        }, {
          clickEvent: "restartTour",
          label: "Take the App Tour Again",
          icon: icons.tour
        },
        //  {
        // 	clickEvent: "updateShowPermissionsScreen",
        // 	clickValue: true,
        // 	clickEventType: 'store',
        // 	label: 'Device Permissions',
        // 	icon: 'fa-user-lock'
        // },
        {
          clickEvent: "showFeedbackSupport",
          label: pageTitles.feedbackSupport,
          icon: icons.feedbackSupport
        },
        // {

        // 	clickEvent: 'https://www.aivitar.com/blog/categories/release-notes',
        // 	clickEventType: 'link',
        // 	label: pageTitles.releaseNotes,
        // 	icon: icons.releaseNotes
        // },
        // {
        // 	clickEvent: 'https://aivitar.com/account/my-account',
        // 	clickEventType: 'link',
        // 	label: 'My Account',
        // 	icon: 'fa-user'
        // },
        {
          clickEvent: "logout",
          clickEventType: "link",
          label: "Log Out",
          icon: "fa-user-lock"
        }]
      },
      // Terms Of Service
      termsOfService: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.termsOfService,
          clickEvent: null,
          icon: icons.termsOfService
        }]
      },
      feedbackSupport: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.feedbackSupport,
          clickEvent: null,
          icon: icons.feedbackSupport
        }]
      },
      // Billing
      billing: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.billing,
          clickEvent: null,
          icon: icons.billing
        }]
      },
      // Policy And Terms
      policyAndTerms: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.policyAndTerms,
          clickEvent: null,
          icon: icons.policiesAndTerms
        }],
        menuItems: [
        // {
        // 	clickEvent: 'showCommunityGuidelines',
        // 	label: 'Community Guidelines',
        // 	icon: icons.communityGuidelines,
        // },
        {
          // clickEvent: 'showTermsOfService',
          clickEvent: "https://aivitar.com/terms-and-conditions",
          clickEventType: "link",
          label: "Terms of Service",
          icon: icons.termsOfService
        }, {
          clickEvent: "https://www.aivitar.com/privacy-policy",
          clickEventType: "link",
          label: "Privacy Policy",
          icon: icons.privacyPolicy
        }
        // {
        // 	clickEvent: 'showCookiePolicy',
        // 	label: 'Cookie Policy',
        // 	icon: icons.cookiePolicy,
        // },
        ]
      },
      releaseNotes: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.releaseNotes,
          clickEvent: null,
          icon: icons.releaseNotes
        }]
      },
      communityGuidelines: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.communityGuidelines,
          clickEvent: null,
          icon: icons.communityGuidelines
        }]
      },
      // Privacy Policy
      privacyPolicy: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.privacyPolicy,
          clickEvent: null,
          icon: icons.privacyPolicy
        }]
        // menuItems: [
        // {localStorage
        // 		clickEvent: 'showTermsOfService',
        // 		label: 'Terms of Service'
        // 	},
        // 	{
        // 		clickEvent: 'showPrivacyPolicy',
        // 		label: 'Privacy Policy'
        // 	},
        // ],
      },
      // Privacy Policy
      avatarSettings: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: pageTitles.avatarSettings,
          clickEvent: null,
          icon: icons.avatarSettings
        }]
        // menuItems: [
        // {
        // 		clickEvent: 'showTermsOfService',
        // 		label: 'Terms of Service'
        // 	},
        // 	{
        // 		clickEvent: 'showPrivacyPolicy',
        // 		label: 'Privacy Policy'
        // 	},
        // ],
      },
      // Terms Of Service
      howToDocs: {
        breadcrumbs: [{
          label: "Main Menu",
          clickEvent: "showMainMenu"
        }, {
          label: "Documentation",
          clickEvent: null,
          icon: icons.howToDocs
        }],
        menuItems: [{
          clickEvent: "showTermsOfService",
          label: "Conversation Settings (Memory, Context, etc.)",
          icon: icons.termsOfService
        }, {
          clickEvent: "showPrivacyPolicy",
          label: "Billing & Subscriptions",
          icon: icons.billing
        }, {
          clickEvent: "showPrivacyPolicy",
          label: "Notifications",
          icon: icons.privacyPolicy
        }]
      }
    };
  },
  created: function created() {
    // created hook
  },
  watch: {
    "showBilling": "getTokenBalance",
    selectedMonth: function selectedMonth() {
      this.updateChart();
    }
  },
  methods: {
    getTokenBalance: function getTokenBalance() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var userToken, axios, qs, data, config, tokenBalance;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              userToken = localStorage.getItem('security');
              axios = require('axios');
              qs = require('qs');
              data = qs.stringify({
                'token': userToken
              });
              config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://dev.aivitar.com/getTokenBalance',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              }; // var localThis = this;
              _context2.next = 7;
              return axios.request(config);
            case 7:
              tokenBalance = _context2.sent;
              _this2.tokenBalance = tokenBalance.data.tokensRemaining;
              if (tokenBalance.tokensRemaining) {
                if (tokenBalance.data.success === false) {
                  _this2.tokenBalanceError = true;
                  // error with getting token balance
                }
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeAllUnderScores: function removeAllUnderScores(label) {
      return label.replace(/_/g, " ");
    },
    extractMonthlyTotals: function extractMonthlyTotals(data) {
      var tokenValue = 0.00012;
      this.monthlyTotals = data.reduce(function (acc, item) {
        var date = new Date(item.date);
        var monthYear = date.toLocaleString("default", {
          month: "long",
          year: "numeric"
        });
        if (!acc[monthYear]) {
          acc[monthYear] = 0;
        }
        acc[monthYear] += item.tokens_used * tokenValue;
        return acc;
      }, {});
    },
    getToken: function getToken() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", localStorage.getItem("security"));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    formatMonth: function formatMonth(date) {
      var dateObj = new Date(date);
      var options = {
        month: "long",
        year: "numeric"
      };
      return dateObj.toLocaleDateString("en-US", options);
    },
    formatDay: function formatDay(date) {
      var dateObj = new Date(date);
      var day = dateObj.getUTCDate().toString().padStart(2, "0");
      return day;
    },
    changeMonth: function changeMonth(month) {
      this.selectedMonth = month;
      this.updateChart();
    },
    updateChart: function updateChart() {
      var _this3 = this;
      var filteredData = this.tokenData.filter(function (item) {
        return _this3.formatMonth(item.date) === _this3.selectedMonth;
      });
      var chartData = filteredData.reduce(function (acc, item) {
        var day = _this3.formatDay(item.date);
        if (acc[day]) {
          acc[day] += item.tokens_used;
        } else {
          acc[day] = item.tokens_used;
        }
        return acc;
      }, {});
      this.chartOptions.plugins.title.display = true;
      this.chartOptions.plugins.title.text = this.selectedMonth;
      this.chartOptions.plugins.title.display = true;
      this.chartOptions.plugins.title.text = this.selectedMonth;
      this.chartOptions.plugins.title.fontSize = 24; // Set title font size to 24px
      // Sort the keys of chartData
      var sortedKeys = Object.keys(chartData).sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      });
      this.chartData = {
        labels: sortedKeys,
        datasets: [{
          label: "Tokens Used",
          backgroundColor: "#36A2EB",
          data: sortedKeys.map(function (key) {
            return chartData[key];
          })
        }]
      };
    },
    extractDay: function extractDay(label) {
      return label.split(" ")[0]; // Extract the day from the label
    },
    closeSidebar: function closeSidebar() {
      this.resetAllMenuViews();
      this.showMainMenu = true;
      this.$store.commit("mainMenuClose");
      this.$store.commit("updateShowMainMenu", false);
      this.$store.commit("updateShowAvatarSettings", false);
      this.$store.commit('updatePreventIntroExperience', false);
    },
    resetAllMenuViews: function resetAllMenuViews() {
      //   this.$store.commit("updateShowMainMenu", false);
      this.$store.commit("updateShowAvatarSettings", false);
      this.showCommunityGuidelines = false;
      this.showMainMenu = false;
      this.showVoiceSettings = false;
      this.showBilling = false;
      this.showTermsOfService = false;
      this.showFeedback = false;
      this.showReleaseNotes = false;
      this.showHowToDocs = false;
      this.showPoliciesAndTerms = false;
      this.showPrivacyPolicy = false;
      this.showAvatarSettings = false;
      this.showFeedbackSupport = false;
    },
    clickEvent: function clickEvent(event) {
      if (event === "restartTour") {
        this.$store.commit("mainMenuClose");
        this.$store.commit("updateShowWalkthrough", true);
      } else {
        if (!event) return;
        this.resetAllMenuViews();
        this[event] = true;
      }
    }
  }
});